import Big from 'big.js';
import fromExponential from 'from-exponential';

import { detectPrecision } from './detectPrecision';

export function truncateNumber(
  number: string | number | null | undefined,
  decimalPlaces = 0,
  rounding: 'up' | 'down' = 'down',
): number {
  if (number === Infinity) return 0;
  if (Number.isNaN(number)) return 0;
  if (number === undefined) return 0;

  const digits = detectPrecision(Number(number));
  const bigNumber = new Big(number || 0);
  const multiplier = new Big(10).pow(decimalPlaces ?? digits);

  let result: Big;

  if (rounding === 'up') {
    result = bigNumber.times(multiplier).round(0, 3); // RoundingMode.CEIL
  } else {
    result = bigNumber.times(multiplier).round(0, 0); // RoundingMode.FLOOR
  }

  return result.div(multiplier).toNumber();
}

export function truncateString(input: string | number | undefined = '', digits = 0): string {
  // Convert the input to a string if it's a number
  const numStr = typeof input === 'number' ? input.toString() : input;

  const hasDot = /\./.test(numStr);

  // Split the string into integer and decimal parts
  const [integerPart, decimalPart] = numStr.toString().split('.');

  // Truncate the decimal part to the specified number of digits
  const truncatedDecimalPart = decimalPart ? decimalPart.slice(0, digits) : '';

  const dot = hasDot ? '.' : '';

  // Combine the integer part and truncated decimal part to form the result
  const result = `${integerPart}${dot}${truncatedDecimalPart}`;

  return fromExponential(hasDot ? result : integerPart);
}
